import React, { useCallback, useEffect, useState } from 'react';
import { Row, Col, Form, Table } from 'react-bootstrap';
import Select from 'react-select';
import axios from 'axios';
import debounce from 'lodash/debounce';
import { BASE_URL } from '../../../services/Api';
import { authHeader } from '../../../services/auth-header';
import { IoMdClose } from 'react-icons/io';

const addressCache = new Map();

function CommonSalesInternationalFields({ onDataChange, initialData }) {
    const [tallyreferenceno, settallyreferenceno] = useState(initialData?.tallyreferenceno || '');
    const [dispatchthrough, setdispatchthrough] = useState(initialData?.dispatchthrough || '');
    const [destination, setdestination] = useState(initialData?.destination || '');
    const [reference, setreference] = useState(initialData?.reference || '');
    const [packinglistno, setpackinglistno] = useState(initialData?.packinglistno || '');
    const [packinglistdate, setpackinglistdate] = useState(initialData?.packinglistdate || '');
    const [buyerorderno, setbuyerorderno] = useState(initialData?.buyerorderno || '');
    const [buyerorderdate, setbuyerorderdate] = useState(initialData?.buyerorderdate || '');

    // New fields for international sales
    const [kindattn, setKindattn] = useState(initialData?.kindattn || '');
    const [countryofdestination, setCountryofdestination] = useState(initialData?.countryofdestination || '');
    const [countryoforigin, setCountryoforigin] = useState(initialData?.countryoforigin || '');
    const [airsea, setAirsea] = useState(initialData?.airsea || '');
    const [portofloading, setPortofloading] = useState(initialData?.portofloading || '');
    const [portofdischarge, setPortofdischarge] = useState(initialData?.portofdischarge || '');

    // New fields added on 4-10-2025
    const [noofboxes, setNoofboxes] = useState(initialData?.noofboxes || '');
    const [netweightofboxes, setNetweightofboxes] = useState(initialData?.netweightofboxes || '');
    const [grossweightofboxes, setGrossweightofboxes] = useState(initialData?.grossweightofboxes || '');
    const [lutbondno, setLutbondno] = useState(initialData?.lutbondno || '');
    const [typeofshippingbill, setTypeofshippingbill] = useState(initialData?.typeofshippingbill || '');
    const [drawbackacno, setDrawbackacno] = useState(initialData?.drawbackacno || '');
    const [chapterheading, setChapterheading] = useState(initialData?.chapterheading || '');
    const [tariffitem, setTariffitem] = useState(initialData?.tariffitem || '');
    const [description, setDescription] = useState(initialData?.description || '');
    const [drawbackrate, setDrawbackrate] = useState(initialData?.drawbackrate || '');
    const [lut, setLut] = useState(initialData?.lut || '');
    const [lutbonddate, setLutbonddate] = useState(initialData?.lutbonddate || '');
    const [fromdate, setFromdate] = useState(initialData?.fromdate || '');
    const [todate, setTodate] = useState(initialData?.todate || '');

    // Existing customer state
    const [customerOptions, setcustomerOptions] = useState([]);
    const [customerSearch, setcustomerSearch] = useState(" ");
    const [customer, setcustomer] = useState(initialData?.customer || null);
    const [iscustomerOpen, setIscustomerOpen] = useState(false);
    const [customerDetails, setcustomerDetails] = useState({
        contactperson: initialData?.customerDetails?.contactperson || '',
        contactno: initialData?.customerDetails?.contactno || '',
        email: initialData?.customerDetails?.email || '',
        paymentterm: initialData?.customerDetails?.paymentterm || '',
        incoterms: initialData?.customerDetails?.incoterms || ''

    });
    const [customerAddresses, setcustomerAddresses] = useState([]);
    const [customerMultipleAddress, setcustomerMultipleAddress] = useState(initialData?.customerMultipleAddress || null);

    const [shipTo, setShipTo] = useState(initialData?.shipTo || null);
    const [billTo, setBillTo] = useState(initialData?.billTo || null);
    // Add state for branch and warehouse
    const [branchOptions, setBranchOptions] = useState([]);
    const [warehouseOptions, setWarehouseOptions] = useState([]);
    const [branch, setBranch] = useState(initialData?.branch || null);
    const [warehouse, setWarehouse] = useState(initialData?.warehouse || null);
    const [isBranchWarehouseOpen, setIsBranchWarehouseOpen] = useState(false);

    // New state for products and currency
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [rows, setRows] = useState(initialData?.rows || []);
    const [productOptions, setProductOptions] = useState([]);
    const [productSearch, setProductSearch] = useState(encodeURIComponent(" "));
    const [exchangeRate, setExchangeRate] = useState(initialData?.exchangeRate || 0);
    const [exportchargescurrency, setexportchargescurrency] = useState(initialData?.exportchargescurrency || 0);
    const [selectedCurrency, setSelectedCurrency] = useState(initialData?.selectedCurrency || "$ (USD)");
    const [isProductOpen, setIsProductOpen] = useState(false);

    // State for new international fields section
    const [isInternationalOpen, setIsInternationalOpen] = useState(false);

    const currencyOptions = [
        { value: "", label: "Select Currency" },
        { value: "$ (USD)", label: "USD" },
        { value: "€ (EUR)", label: "EUR" },
        { value: "¥ (JPY)", label: "JPY" },
        { value: "£ (GBP)", label: "GBP" },
        { value: "₹ (INR)", label: "INR" },
    ];

    const unitOptions = [
        { value: "", label: "Select UOM" },
        { value: "bot", label: "Bot" },
        { value: "ctn", label: "Ctn" },
        { value: "days", label: "Days" },
        { value: "ft", label: "Ft" },
        { value: "hrs", label: "Hrs" },
        { value: "kg", label: "Kg" },
        { value: "ltr", label: "Ltr" },
        { value: "mtr", label: "Mtr" },
        { value: "nos", label: "Nos" },
        { value: "pil", label: "Pil" },
        { value: "pkt", label: "Pkt" },
        { value: "set", label: "Set" },
        { value: "pcs", label: "Pcs" }
    ];

    const airSeaOptions = [
        { value: "", label: "Select Option" },
        { value: "air", label: "Air" },
        { value: "sea", label: "Sea" }
    ];

    // Formatting functions
    const formatNumberWithCommas = (num) => {
        if (num === null || num === undefined) return '0.00';
        return parseFloat(num).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    const toWords = (num) => {
        const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
        const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
        const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];

        function convertLessThanOneThousand(num) {
            if (num === 0) return '';
            if (num < 10) return ones[num];
            if (num < 20) return teens[num - 10];
            if (num < 100) return tens[Math.floor(num / 10)] + (num % 10 !== 0 ? ' ' + ones[num % 10] : '');
            return ones[Math.floor(num / 100)] + ' Hundred' + (num % 100 !== 0 ? ' ' + convertLessThanOneThousand(num % 100) : '');
        }

        if (num === 0) return 'Zero';

        if (num < 100000) {
            const thousandPart = Math.floor(num / 1000);
            const remainder = num % 1000;
            let result = '';
            if (thousandPart > 0) {
                result += convertLessThanOneThousand(thousandPart) + ' Thousand';
            }
            if (remainder > 0) {
                result += (result ? ' ' : '') + convertLessThanOneThousand(remainder);
            }
            return result;
        }

        const scales = ['', 'Thousand', 'Lakh', 'Crore', 'Arab', 'Kharab', 'Neel', 'Padma', 'Shankh'];
        let result = '';
        let scaleIndex = 0;
        let remaining = num;

        while (remaining > 0) {
            const chunk = remaining % 100;
            remaining = Math.floor(remaining / 100);

            if (chunk !== 0) {
                let chunkWords = convertLessThanOneThousand(chunk);
                if (scaleIndex > 0) {
                    chunkWords += ' ' + scales[scaleIndex];
                }
                result = chunkWords + ' ' + result;
            }
            scaleIndex++;

            if (scaleIndex >= 2) {
                const bigChunk = remaining % 100;
                remaining = Math.floor(remaining / 100);
                if (bigChunk !== 0) {
                    let bigChunkWords = convertLessThanOneThousand(bigChunk);
                    if (scaleIndex > 0) {
                        bigChunkWords += ' ' + scales[scaleIndex];
                    }
                    result = bigChunkWords + ' ' + result;
                }
                scaleIndex++;
            }
        }

        return result.trim();
    };

    const numberToWordsWithRupees = (num) => {
        const amount = Math.round(num);
        return `${toWords(amount)} Rupees Only`;
    };

    // Handle Ship To change
    const handleShipToChange = (selectedOption) => {
        setShipTo(selectedOption);
    };

    // Handle Bill To change
    const handleBillToChange = (selectedOption) => {
        setBillTo(selectedOption);
    };

    // Handle customer details change
    const handleCustomerDetailsChange = (field, value) => {
        setcustomerDetails(prev => ({
            ...prev,
            [field]: value
        }));
    };

    useEffect(() => {
        if (initialData?.customer?.value) {
            getcustomerAddresses(initialData.customer.value);
        }
        getBranchData();
        getWarehouseData();
    }, [initialData]);

    const handleSearchChangecustomer = debounce((inputValue) => {
        setcustomerSearch(inputValue || " ");
    }, 300);

    useEffect(() => {
        getcustomerData();
    }, [customerSearch]);

    const getcustomerData = async () => {
        try {
            const response = await axios.get(
                `${BASE_URL}customer/page/0/10/asc/id/${encodeURIComponent(customerSearch)}`,
                { headers: authHeader() }
            );

            const customers = response.data.Index || response.data.data || [];

            setcustomerOptions(
                customers.map((s) => ({
                    value: s.id,
                    label: s.companyname,
                    contactperson: s.contactperson,
                    contactno: s.contactno,
                    email: s.email,
                    paymentterm: s.paymentterm,
                    incoterms: s.incoterms,
                }))
            );
        } catch (error) {
            console.error("Error fetching customer data", error);
        }
    };

    const getcustomerAddresses = useCallback(async (id) => {
        if (!id) return;

        if (addressCache.has(id)) {
            const cachedAddresses = addressCache.get(id);
            setcustomerAddresses(cachedAddresses);

            if (initialData && !shipTo && !billTo) {
                if (initialData.shipTo) {
                    const shipToAddress = cachedAddresses.find(
                        addr => addr.value === initialData.shipTo.value
                    );
                    setShipTo(shipToAddress || null);
                }
                if (initialData.billTo) {
                    const billToAddress = cachedAddresses.find(
                        addr => addr.value === initialData.billTo.value
                    );
                    setBillTo(billToAddress || null);
                }
            }
            return;
        }

        try {
            const response = await axios.get(`${BASE_URL}customerMultipleAddress/getAddress/${id}`, {
                headers: authHeader(),
            });

            const formattedAddresses = response.data.map(addr => ({
                value: addr.id,
                label: addr.customeraddress,
                address: addr
            }));

            addressCache.set(id, formattedAddresses);
            setcustomerAddresses(formattedAddresses);

            if (initialData && !shipTo && !billTo) {
                if (initialData.shipTo) {
                    const shipToAddress = formattedAddresses.find(
                        addr => addr.value === initialData.shipTo.value
                    );
                    setShipTo(shipToAddress || null);
                }
                if (initialData.billTo) {
                    const billToAddress = formattedAddresses.find(
                        addr => addr.value === initialData.billTo.value
                    );
                    setBillTo(billToAddress || null);
                }
            }
        } catch (error) {
            console.error("Error fetching customer addresses", error);
        }
    }, [initialData, shipTo, billTo]);

    useEffect(() => {
        if (initialData?.customer?.value) {
            getcustomerAddresses(initialData.customer.value);
        }
        getBranchData();
        getWarehouseData();
    }, [initialData?.customer?.value, getcustomerAddresses]);

    const handlecustomerChange = useCallback((selected) => {
        setcustomer(selected);
        if (selected) {
            setcustomerDetails({
                contactperson: selected.contactperson,
                contactno: selected.contactno,
                email: selected.email,
                paymentterm: selected.paymentterm,
                incoterms: selected.incoterms,
            });
            getcustomerAddresses(selected.value);
            setIscustomerOpen(true);
        } else {
            setcustomerDetails({
                contactperson: '',
                contactno: '',
                email: '',
                paymentterm: '',
                incoterms: ''
            });
            setcustomerAddresses([]);
            setShipTo(null);
            setBillTo(null);
        }
        setcustomerMultipleAddress(null);
    }, [getcustomerAddresses]);

    const handleProductSearchChange = debounce((inputValue) => {
        setProductSearch(inputValue ? encodeURIComponent(inputValue) : encodeURIComponent(" "));
    }, 500);

    const getProductData = async () => {
        try {
            const response = await axios.get(
                `${BASE_URL}product/page/ptype/0/10/desc/id/2/Finished,Raw Material, Semi Finished,Services/${productSearch}`,
                { headers: authHeader() }
            );

            const products = response.data.Index || response.data.data || [];
            setProductOptions(
                products.map(product => ({
                    value: product.id,
                    label: `${product.description} - ${product.serialnumber} - ${product.partno}`,
                    description: product.description,
                    partno: product.partno || '',
                    serialnumber: product.serialnumber || '',
                    modelnumber: product.modelnumber || '',
                    tagnumber: product.tagnumber || '',
                    moc: product.moc || '',
                    itemcode: product.itemcode || '',
                    hsnsacno: product.hsnsacno || '',
                    uom: product.unitofmeasurement || 'pcs (pcs)',
                    unitrateinr: product.unitrate || 0,
                }))
            );
        } catch (error) {
            console.error("Error fetching products", error);
        }
    };

    useEffect(() => {
        getProductData();
    }, [productSearch]);

    const handleProductChange = (selectedOption) => {
        setSelectedProduct(selectedOption);
        const selectedProductData = productOptions.find(product => product.value === selectedOption.value);

        if (selectedProductData) {
            const newRow = {
                description: selectedProductData.description,
                value: selectedProductData.value,
                productremarks: "",
                quantity: 0,
                unitratecurrency: 0,
                totalcurrency: 0,
                exchangerate: exchangeRate,
                unitRateInr: 0,
                totalInr: 0,
                hsnsacno: selectedProductData.hsnsacno,
                itemcode: selectedProductData.itemcode,
                serialnumber: selectedProductData.serialnumber,
                modelnumber: selectedProductData.modelnumber,
                tagnumber: selectedProductData.tagnumber,
                moc: selectedProductData.moc,
                partno: selectedProductData.partno,
                uom: selectedProductData.uom,
                currency: selectedCurrency,
            };
            setRows([...rows, newRow]);
            handleDataUpdate();
        }
    };

    const handleRowChange = (index, key, value) => {
        const updatedRows = [...rows];
        updatedRows[index][key] = value;

        if (key === 'quantity' || key === 'unitratecurrency' || key === 'exchangerate') {
            const quantity = parseFloat(updatedRows[index].quantity) || 0;
            const unitratecurrency = parseFloat(updatedRows[index].unitratecurrency) || 0;
            const currentExchangeRate = parseFloat(updatedRows[index].exchangerate) || exchangeRate;

            updatedRows[index].unitRateInr = unitratecurrency * currentExchangeRate;
            updatedRows[index].totalInr = quantity * updatedRows[index].unitRateInr;
            updatedRows[index].totalcurrency = quantity * unitratecurrency;
        }

        setRows(updatedRows);
        handleDataUpdate();
    };

    const removeRow = (index) => {
        const updatedRows = [...rows];
        updatedRows.splice(index, 1);
        setRows(updatedRows);
        handleDataUpdate();
    };

    const toggleProductSection = () => {
        setIsProductOpen(!isProductOpen);
    };

    const toggleInternationalSection = () => {
        setIsInternationalOpen(!isInternationalOpen);
    };

    // BRANCH AND WAREHOUSE 
    const handleBranchChange = (selected) => {
        setBranch(selected);
    };

    const handleWarehouseChange = (selected) => {
        setWarehouse(selected);
    };

    const toggleBranchWarehouseSection = () => {
        setIsBranchWarehouseOpen(!isBranchWarehouseOpen);
    };

    const getBranchData = async () => {
        try {
            const response = await axios.get(`${BASE_URL}branch/findAllBranch`, {
                headers: authHeader(),
            });
            setBranchOptions(response.data.map(b => ({ value: b.id, label: b.branchname })));
        } catch (error) {
            console.error("Error fetching branches", error);
        }
    };

    const getWarehouseData = async () => {
        try {
            const response = await axios.get(`${BASE_URL}warehouse/findAllWarehouse`, {
                headers: authHeader(),
            });
            setWarehouseOptions(response.data.map(w => ({ value: w.id, label: w.warehousename })));
        } catch (error) {
            console.error("Error fetching warehouses", error);
        }
    };

    const handleDataUpdate = () => {
        if (onDataChange) {
            onDataChange({
                customer,
                customerDetails,
                customerMultipleAddress,
                shipTo,
                billTo,
                branch,
                warehouse,

                tallyreferenceno,
                dispatchthrough,
                destination,
                reference,
                packinglistno,
                packinglistdate,
                buyerorderno,
                buyerorderdate,

                // New international fields
                kindattn,
                countryofdestination,
                countryoforigin,
                airsea,
                portofloading,
                portofdischarge,
                noofboxes,
                netweightofboxes,
                grossweightofboxes,
                lutbondno,
                typeofshippingbill,
                drawbackacno,
                chapterheading,
                tariffitem,
                description,
                drawbackrate,
                lut,
                lutbonddate,
                fromdate,
                todate,

                // Include all product-related state
                rows,
                exchangeRate,
                exportchargescurrency,
                exportpreperationcharges: exportchargescurrency * exchangeRate,
                selectedCurrency,
                // Include calculated totals
                netTotalInr: rows.reduce((total, row) => total + (row.totalInr || 0), 0),
                netTotalCurrency: rows.reduce((total, row) => total + (row.totalcurrency || 0), 0),
                grandTotalInr: rows.reduce((total, row) => total + (row.totalInr || 0), 0) + (exportchargescurrency * exchangeRate),
                grandTotalCurrency: rows.reduce((total, row) => total + (row.totalcurrency || 0), 0) + exportchargescurrency
            });
        }
    };

    useEffect(() => {
        handleDataUpdate();
    }, [
        customer, customerDetails, customerMultipleAddress, shipTo, billTo, branch,
        warehouse, rows, exchangeRate, exportchargescurrency, selectedCurrency,
        kindattn, countryofdestination, countryoforigin, airsea, portofloading,
        portofdischarge, noofboxes, netweightofboxes, grossweightofboxes, lutbondno,
        typeofshippingbill, drawbackacno, chapterheading, tariffitem, description,
        drawbackrate, lut, lutbonddate, fromdate, todate
    ]);

    const togglecustomerSection = () => {
        setIscustomerOpen(!iscustomerOpen);
    };

    return (
        <>
            <Row>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label>Quotation No</Form.Label>
                        <Form.Control
                            type="text"
                            value={tallyreferenceno}
                            onChange={(e) => settallyreferenceno(e.target.value)}
                        />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label>Dispatch Through</Form.Label>
                        <Form.Control
                            type="text"
                            value={dispatchthrough}
                            onChange={(e) => setdispatchthrough(e.target.value)}
                        />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label>Destination</Form.Label>
                        <Form.Control
                            type="text"
                            value={destination}
                            onChange={(e) => setdestination(e.target.value)}
                        />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label>Reference</Form.Label>
                        <Form.Control
                            type="text"
                            value={reference}
                            onChange={(e) => setreference(e.target.value)}
                        />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label>Packing list No</Form.Label>
                        <Form.Control
                            type="text"
                            value={packinglistno}
                            onChange={(e) => setpackinglistno(e.target.value)}
                        />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label>Packing list Date</Form.Label>
                        <Form.Control
                            type="date"
                            value={packinglistdate}
                            onChange={(e) => setpackinglistdate(e.target.value)}
                        />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label>Buyer Order No</Form.Label>
                        <Form.Control
                            type="text"
                            value={buyerorderno}
                            onChange={(e) => setbuyerorderno(e.target.value)}
                        />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label>Buyer Order Date</Form.Label>
                        <Form.Control
                            type="date"
                            value={buyerorderdate}
                            onChange={(e) => setbuyerorderdate(e.target.value)}
                        />
                    </Form.Group>
                </Col>
            </Row>
            <br />

            {/* New International Sales Fields Section */}
            <div className="supplier-accordion-container">
                <div
                    className={`supplier-accordion-header ${isInternationalOpen ? 'supplier-accordion-open' : ''}`}
                    onClick={toggleInternationalSection}
                >
                    <h7>International Sales Details</h7>
                    <span className="supplier-accordion-icon">
                        {isInternationalOpen ? '−' : '+'}
                    </span>
                </div>

                <div className={`supplier-accordion-content ${isInternationalOpen ? 'supplier-accordion-content-show' : ''}`}>
                    <Row>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Kind Attention</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={kindattn}
                                    onChange={(e) => setKindattn(e.target.value)}
                                    placeholder="Enter kind attention"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Country of Destination</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={countryofdestination}
                                    onChange={(e) => setCountryofdestination(e.target.value)}
                                    placeholder="Enter country of destination"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Country of Origin</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={countryoforigin}
                                    onChange={(e) => setCountryoforigin(e.target.value)}
                                    placeholder="Enter country of origin"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Air/Sea</Form.Label>
                                <Select
                                    options={airSeaOptions}
                                    value={airSeaOptions.find(option => option.value === airsea)}
                                    onChange={(selectedOption) => setAirsea(selectedOption?.value || '')}
                                    placeholder="Select Air or Sea"
                                    isClearable
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Port of Loading</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={portofloading}
                                    onChange={(e) => setPortofloading(e.target.value)}
                                    placeholder="Enter port of loading"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Port of Discharge</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={portofdischarge}
                                    onChange={(e) => setPortofdischarge(e.target.value)}
                                    placeholder="Enter port of discharge"
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <hr />
                    <h6>Additional International Details</h6>
                    <Row>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>No. of Boxes</Form.Label>
                                <Form.Control
                                    type="number"
                                    value={noofboxes}
                                    onChange={(e) => setNoofboxes(e.target.value)}
                                    placeholder="Enter number of boxes"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>Net Weight of Boxes (kg)</Form.Label>
                                <Form.Control
                                    type="number"
                                    step="0.01"
                                    value={netweightofboxes}
                                    onChange={(e) => setNetweightofboxes(e.target.value)}
                                    placeholder="Enter net weight"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>Gross Weight of Boxes (kg)</Form.Label>
                                <Form.Control
                                    type="number"
                                    step="0.01"
                                    value={grossweightofboxes}
                                    onChange={(e) => setGrossweightofboxes(e.target.value)}
                                    placeholder="Enter gross weight"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>LUT Bond No</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={lutbondno}
                                    onChange={(e) => setLutbondno(e.target.value)}
                                    placeholder="Enter LUT bond number"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>LUT Bond Date</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={lutbonddate}
                                    onChange={(e) => setLutbonddate(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Type of Shipping Bill</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={typeofshippingbill}
                                    onChange={(e) => setTypeofshippingbill(e.target.value)}
                                    placeholder="Enter type of shipping bill"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Drawback A/C No</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={drawbackacno}
                                    onChange={(e) => setDrawbackacno(e.target.value)}
                                    placeholder="Enter drawback account number"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>Chapter Heading</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={chapterheading}
                                    onChange={(e) => setChapterheading(e.target.value)}
                                    placeholder="Enter chapter heading"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>Tariff Item</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={tariffitem}
                                    onChange={(e) => setTariffitem(e.target.value)}
                                    placeholder="Enter tariff item"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>Drawback Rate</Form.Label>
                                <Form.Control
                                    type="number"
                                    step="0.01"
                                    value={drawbackrate}
                                    onChange={(e) => setDrawbackrate(e.target.value)}
                                    placeholder="Enter drawback rate"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Description</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    placeholder="Enter description"
                                />
                            </Form.Group>
                        </Col>
                        {/* <Col md={6}>
                            <Form.Group>
                                <Form.Label>LUT</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    value={lut}
                                    onChange={(e) => setLut(e.target.value)}
                                    placeholder="Enter LUT details"
                                />
                            </Form.Group>
                        </Col> */}
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>From Date</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={fromdate}
                                    onChange={(e) => setFromdate(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>To Date</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={todate}
                                    onChange={(e) => setTodate(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </div>
            </div>

            {/* Existing customer section */}
            <div className="supplier-accordion-container">
                <div
                    className={`supplier-accordion-header ${iscustomerOpen ? 'supplier-accordion-open' : ''}`}
                    onClick={togglecustomerSection}
                >
                    <h7>Customer Information</h7>
                    <span className="supplier-accordion-icon">
                        {iscustomerOpen ? '−' : '+'}
                    </span>
                </div>

                <div className={`supplier-accordion-content ${iscustomerOpen ? 'supplier-accordion-content-show' : ''}`}>
                    <Row>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Customer</Form.Label>
                                <Select
                                    options={customerOptions}
                                    onChange={handlecustomerChange}
                                    onInputChange={handleSearchChangecustomer}
                                    value={customer}
                                    placeholder="Select customer"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 })
                                    }}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Contact Person</Form.Label>
                                <Form.Control
                                    value={customerDetails.contactperson}
                                    disabled
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Phone</Form.Label>
                                <Form.Control
                                    value={customerDetails.contactno}
                                    disabled
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                    value={customerDetails.email}
                                    disabled
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Customer Address</Form.Label>
                                <Select
                                    options={customerAddresses}
                                    value={customerMultipleAddress}
                                    onChange={(val) => setcustomerMultipleAddress(val)}
                                    isClearable
                                    placeholder="Select address"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 })
                                    }}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Ship To:</Form.Label>
                                <Select
                                    options={customerAddresses}
                                    placeholder="Select Ship To Address"
                                    onChange={handleShipToChange}
                                    value={customerAddresses.find(opt => opt.value === shipTo?.value)}
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 })
                                    }}
                                    getOptionValue={option => option.value}
                                    getOptionLabel={option => option.label}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Bill To:</Form.Label>
                                <Select
                                    options={customerAddresses}
                                    placeholder="Select Bill To Address"
                                    onChange={handleBillToChange}
                                    value={customerAddresses.find(opt => opt.value === billTo?.value)}
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 })
                                    }}
                                    getOptionValue={option => option.value}
                                    getOptionLabel={option => option.label}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Payment Term</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={customerDetails.paymentterm}
                                    onChange={e => handleCustomerDetailsChange('paymentterm', e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>INCO Term</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={customerDetails.incoterms}
                                    onChange={e => handleCustomerDetailsChange('incoterms', e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </div>
            </div>

            {/* Branch & Warehouse Custom Accordion */}
            <div className="supplier-accordion-container">
                <div
                    className={`supplier-accordion-header ${isBranchWarehouseOpen ? 'supplier-accordion-open' : ''}`}
                    onClick={toggleBranchWarehouseSection}
                >
                    <h7 className="mb-0">Branch & Warehouse Details</h7>
                    <span className="supplier-accordion-icon">
                        {isBranchWarehouseOpen ? '−' : '+'}
                    </span>
                </div>

                <div className={`supplier-accordion-content ${isBranchWarehouseOpen ? 'supplier-accordion-content-show' : ''}`}>
                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Branch</Form.Label>
                                <Select
                                    value={branch}
                                    onChange={handleBranchChange}
                                    options={branchOptions}
                                    placeholder="Select branch"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 })
                                    }}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Warehouse</Form.Label>
                                <Select
                                    value={warehouse}
                                    onChange={handleWarehouseChange}
                                    options={warehouseOptions}
                                    placeholder="Select warehouse"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 })
                                    }}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </div>
            </div>

            {/* Product and Currency Section */}
            <div className="supplier-accordion-container mt-3">
                <div
                    className={`supplier-accordion-header ${isProductOpen ? 'supplier-accordion-open' : ''}`}
                    onClick={toggleProductSection}
                >
                    <h7>Product & Currency Information</h7>
                    <span className="supplier-accordion-icon">
                        {isProductOpen ? '−' : '+'}
                    </span>
                </div>

                <div className={`supplier-accordion-content ${isProductOpen ? 'supplier-accordion-content-show' : ''}`}>
                    {/* ... (existing product and currency section code remains the same) */}
                    <Row>
                        <Col md="6">
                            <Form.Group controlId="currency">
                                <Form.Label>Currency</Form.Label>
                                <Select
                                    value={currencyOptions.find(option => option.value === selectedCurrency)}
                                    onChange={(selectedOption) => {
                                        setSelectedCurrency(selectedOption.value);
                                        const updatedRows = rows.map(row => ({
                                            ...row,
                                            currency: selectedOption.value
                                        }));
                                        setRows(updatedRows);
                                    }}
                                    options={currencyOptions}
                                    placeholder="Select Currency"
                                />
                            </Form.Group>
                        </Col>
                        <Col md="6">
                            <Form.Group controlId="exchangeRate">
                                <Form.Label>Exchange Rate</Form.Label>
                                <Form.Control
                                    type="number"
                                    value={exchangeRate || ''}
                                    onChange={(e) => {
                                        setExchangeRate(e.target.value);
                                        const updatedRows = rows.map(row => ({
                                            ...row,
                                            exchangerate: e.target.value,
                                            unitRateInr: (row.unitratecurrency || 0) * e.target.value,
                                            totalInr: (row.quantity || 0) * (row.unitratecurrency || 0) * e.target.value
                                        }));
                                        setRows(updatedRows);
                                    }}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <hr />
                    <br />

                    <Row>
                        <Col md='12'>
                            <Form.Group>
                                <Form.Label>Select Product</Form.Label>
                                <Select
                                    value={selectedProduct}
                                    onChange={handleProductChange}
                                    options={productOptions}
                                    placeholder="Search and select product"
                                    onInputChange={handleProductSearchChange}
                                    isClearable
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <br />

                    <div className="table-responsive">
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>Product Description</th>
                                    <th>Serial No.</th>
                                    <th>Model No.</th>
                                    <th>Tag No.</th>
                                    <th>Part No.</th>
                                    <th>MOC</th>
                                    <th>Item Code</th>
                                    <th>HSN/SAC No.</th>
                                    <th>Quantity</th>
                                    <th>Unit of Measurement</th>
                                    <th>Currency</th>
                                    <th>Unit Rate (Currency)</th>
                                    <th>Total (Currency)</th>
                                    <th>Exchange Rate</th>
                                    <th>Unit Price (INR)</th>
                                    <th>Total Amount (INR)</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((row, index) => (
                                    <tr key={index}>
                                        <td>
                                            {row.description}
                                            <Form.Control as="textarea" rows={2}
                                                className="remarks"
                                                type="text"
                                                value={row.productremarks}
                                                onChange={(e) => handleRowChange(index, 'productremarks', e.target.value)}
                                                placeholder="Enter item remarks"
                                            />
                                        </td>
                                        <td>{row.serialnumber}</td>
                                        <td>{row.modelnumber}</td>
                                        <td>{row.tagnumber}</td>
                                        <td>{row.partno}</td>
                                        <td>{row.moc}</td>
                                        <td>{row.itemcode}</td>
                                        <td>{row.hsnsacno}</td>
                                        <td>
                                            <Form.Control
                                                min="0"
                                                className="quantity"
                                                type="number"
                                                value={row.quantity || ''}
                                                onChange={(e) => handleRowChange(index, 'quantity', e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <Select
                                                className="uom"
                                                value={unitOptions.find(option => option.value === row.uom)}
                                                onChange={(selectedOption) => handleRowChange(index, 'uom', selectedOption.value)}
                                                options={unitOptions}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                                }}
                                            />
                                        </td>
                                        <td>
                                            <Select
                                                className="currency"
                                                value={currencyOptions.find(option => option.value === row.currency)}
                                                options={[currencyOptions.find(option => option.value === row.currency)]}
                                                isDisabled
                                            />
                                        </td>
                                        <td>
                                            <Form.Control
                                                min="0"
                                                className="unitrate"
                                                type="number"
                                                value={row.unitratecurrency || ''}
                                                onChange={(e) => handleRowChange(index, 'unitratecurrency', e.target.value)}
                                            />
                                        </td>
                                        <td>{(row.totalcurrency || 0).toFixed(2)}</td>
                                        <td>
                                            <Form.Control
                                                min="0"
                                                type="number"
                                                value={row.exchangerate || exchangeRate}
                                                onChange={(e) => handleRowChange(index, 'exchangerate', e.target.value)}
                                                className="exchangerate"
                                            />
                                        </td>
                                        <td>{(row.unitRateInr || 0).toFixed(2)}</td>
                                        <td>{(row.totalInr || 0).toFixed(2)}</td>
                                        <td>
                                            <IoMdClose onClick={() => removeRow(index)} />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>

                    <div className="card mt-3" style={{ width: '50%', marginLeft: 'auto' }}>
                        <div className="card-header bg-light">
                            <h5 className="mb-0">Quotation Summary</h5>
                        </div>
                        <div className="card-body">
                            <div className="row mb-2">
                                <div className="col-8 text-end">
                                    <strong>Net Total (INR)</strong>
                                </div>
                                <div className="col-4">
                                    <strong>{formatNumberWithCommas(rows.reduce((total, row) => total + (row.totalInr || 0), 0))}</strong>
                                </div>
                            </div>

                            <div className="row mb-2">
                                <div className="col-8 text-end">
                                    <strong>Net Total (Currency)</strong>
                                </div>
                                <div className="col-4">
                                    <strong>{formatNumberWithCommas(rows.reduce((total, row) => total + (row.totalcurrency || 0), 0))}</strong>
                                </div>
                            </div>

                            <div className="row mb-2">
                                <div className="col-8 text-end">
                                    <strong>Export Charges (Currency)</strong>
                                </div>
                                <div className="col-4">
                                    <Form.Control
                                        type="number"
                                        min="0"
                                        value={exportchargescurrency || ''}
                                        onChange={(e) => setexportchargescurrency(parseFloat(e.target.value) || 0)}
                                        className="form-control-sm"
                                    />
                                </div>
                            </div>

                            <div className="row mb-2">
                                <div className="col-8 text-end">
                                    <strong>Export Charges (INR)</strong>
                                </div>
                                <div className="col-4">
                                    <strong>{formatNumberWithCommas(exportchargescurrency * exchangeRate)}</strong>
                                </div>
                            </div>

                            <div className="row mt-3 pt-2 border-top">
                                <div className="col-8 text-end">
                                    <h5>Grand Total (INR)</h5>
                                </div>
                                <div className="col-4">
                                    <h5>{formatNumberWithCommas(
                                        rows.reduce((total, row) => total + (row.totalInr || 0), 0) +
                                        (exportchargescurrency * exchangeRate)
                                    )}</h5>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12 text-end">
                                    <em>{numberToWordsWithRupees(
                                        rows.reduce((total, row) => total + (row.totalInr || 0), 0) +
                                        (exportchargescurrency * exchangeRate)
                                    )}</em>
                                </div>
                            </div>

                            <div className="row mt-2">
                                <div className="col-8 text-end">
                                    <h5>Grand Total (Currency)</h5>
                                </div>
                                <div className="col-4">
                                    <h5>{formatNumberWithCommas(
                                        rows.reduce((total, row) => total + (row.totalcurrency || 0), 0) +
                                        exportchargescurrency
                                    )}</h5>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CommonSalesInternationalFields;